export default __webpack_public_path__ + "static/media/about_3.67d8447f.png";